import { Component, output, ChangeDetectionStrategy } from '@angular/core'
import { RouterModule } from '@angular/router'
import { NgIconComponent, provideIcons } from '@ng-icons/core'
import {
    lucideCreditCard,
    lucideLayoutDashboard,
    lucideShieldCheck,
    lucideStore,
    lucideUsers,
} from '@ng-icons/lucide'
import { superAdminNavigationGroups } from './sidebar-admin.data'

@Component({
    selector: 'app-sidebar-admin',
    standalone: true,
    imports: [RouterModule, NgIconComponent],
    templateUrl: './sidebar-admin.component.html',
    styleUrl: './sidebar-admin.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        provideIcons({
            lucideCreditCard,
            lucideLayoutDashboard,
            lucideShieldCheck,
            lucideStore,
            lucideUsers,
        }),
    ],
})
export class SidebarAdminComponent {
    readonly navigationGroups = superAdminNavigationGroups

    /** Emitted after a nav item was clicked (closes the mobile drawer). */
    readonly navigated = output<void>()
}
